<template>
    <div id="landing-banner">
        <!--=====================================-->
        <!--=        Banner Area Start         =-->
        <!--=====================================-->
        <section class="banner banner-style-2 fix-banner">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-xl-7 col-xxl-7">
                        <div class="banner-content" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">
                            <h2 class="bold title mb--10 text-wrap-balance">Invierte y promueve el <span class="primary">desarrollo sostenible</span> de México</h2>
                            <!-- <h5 class="font-weight-100 mb--50 white">Financia proyectos ambientales a través <br> de una plataforma regulada.</h5> -->
                            <!-- <div class="row mb--50 footer-logos">
                                <div v-for="(item, index) in entities" class="col-lg-2 text-align-center p-0 mb-1">
                                    <img :src="`${imgBase}${item.img}`" :alt="item.title">
                                </div>
                            </div> -->
                        </div>
                    </div>

                    <!-- BANNER FORM -->
                    <div class="col-lg-6 col-xl-5 col-xxl-4">
                        <div class="banner-form" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">
                            <div class="contact-form-box shadow-box">
                                <h3 class="title">Gana en promedio el {{ isMounted ? parseFloat((rgStats.net_yield || 0), 1) : '--' }}%* anual.</h3>
                                <form class="axil-contact-form">
                                    <div class="form-group">
                                        <label>Correo</label>
                                        <input v-model.trim="email" type="email" class="form-control" name="contact-email" placeholder="mario@molina.com">
                                        <small v-if="emailFailed">Antes de continuar, escribe un correo válido.</small>
                                    </div>
                                    <!-- <div class="form-group mb--40">
                                        <label>Teléfono</label>
                                        <input type="tel" class="form-control" name="contact-company" placeholder="+123456789">
                                    </div> -->
                                    <div class="form-group">
                                        <button @click.stop="goToInvestorOnboarding()" class="axil-btn btn-borderd btn-fluid btn-primary rg-style-button " name="submit-btn">Comenzar a invertir</button>
                                    </div>
                                    <input type="hidden" class="form-control" name="contact-message" value="Null">

                                    <p class="mb--10">
                                        *Rendimiento neto promedio de los últimos 12 meses. <router-link class="rg-a" :to="{ name: 'yieldPage' }">Conoce más.</router-link>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
const entities = [
  { title: "SHCP", img: "logo-footer-shcp.png", url: ""},
  { title: "CNBV", img: "logo-footer-cnbv.png", url: ""},
  { title: "BANXICO", img: "logo-footer-banxico.png", url: ""},
  { title: "CONDUSEF", img: "logo-footer-condusef.png", url: ""}
]
export default {
    name: "LandingBanner",
    props: ["rgStats", "isMounted"],
    components: {
    },
    data() {
        return  {
            email: null,
            emailFailed: false,
            investorUrlBase: process.env.VUE_APP_REGISTER_INVESTOR_URL,
            entities: entities,
            imgBase: "https://cdn.redgirasol.com/nuevo_portal/logos/footer/"
        }
    },
    methods: {
        goToInvestorOnboarding()
        {
            if(this.validateEmail(this.email) && this.email != "" && this.email != null) {
                window.open(`${this.investorUrlBase}/?email=${this.email}`, "_blank");
                this.emailFailed = false;
            } else {
                this.emailFailed = true;
            }
        }
    }
}

</script>

<style scoped>

/* .fix-banner {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
} */

.banner-style-2 {
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/banners/banner-home-1.png");
    background-repeat: no-repeat;
    background-size: cover;
    padding: 150px 0 150px 200px;
}


.footer-logos {
  justify-content: left;
  align-items: center;
}

@media only screen and (min-width: 1200px) and (max-width: 1599px) {
    .banner-style-2 {
        padding: 60px 30px 60px 40px;
    }
}

@media only screen and (max-width: 575px) {
    .banner.banner-style-2 {
        padding: 80px 30px;
    }
}
/*
@media only screen and (max-width: 991px) {
    .banner.banner-style-2 {
        padding: 150px 60px;
    }
} */

</style>